import "../../App.css";
import { Container, Row, ProfileContainer } from "../ui/Containers";
import { IntroText, TextAndButton } from "../ui/BoldTextComponents";
import proProfile from "../../assets/images/johnwanderaProBg.jpg";
import WorkContainer from "../ui/workComponent";
import ContactInfo from "../ui/ContactComponet";
import { useTheme } from "../../context/ThemeContext";
import styled from "styled-components";
import DevProcess from "../ui/devProcessComponent";
import ParticleBackground from "../ui/EngineParticles";
import AnimatedText from "../ui/Animation/AnimatedText";
import Parallax from "../ui/Parallax";
import { useState } from "react";
import PageTransition from "../../utils/TransitionPage";
import { useAuth } from "../../context/AuthContext";
// import Reveal from "../ui/Reveal";

const HomeColumn = styled.div`
  display: flex;
  // border: 1px solid black;
  // flex-direction: column;
  justify-content: start;
  align-items: center;
  position: relative;
  overflow: hidden;
`;

const AlignContent = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: startr;
  // border: 1px solid black;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

const ProfilAlign = styled.div`
  // border: 1px solid black;
  margin-right: 10rem;
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 3rem;
    margin-top: 4rem;
    width: 100%;
  }
`;

const IntroTextAndBtn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .introTextDiv {
    // border: 1px solid black;
    text-align: center;
    @media (max-width: 576px) {
      text-align: start;
    }
  }
  @media (max-width: 768px) {
    justify-content: center;
    align-items: center;
    padding: 0 10px;
  }
`;

const Home: React.FC = () => {
  const { theme } = useTheme();
  const [showTransition, setShowTransition] = useState(true);
   const { isProjectLoading, fetchedProjects, FetchLoader } = useAuth();

const phrase =
  "Plan, Build, Ship. That’s what I do. <br />Building powerful APIs and secure systems that scale. <br />Backend-first thinking. Real-world impact.";

  return (
    <>
      {showTransition && (
        <PageTransition onFinish={() => setShowTransition(false)} />
      )}

      {!showTransition && (
        <Container>
          <Row>
            <HomeColumn className="App-col">
              <ParticleBackground />
              <AlignContent>
                <IntroText />
                <ProfilAlign>
                  <ProfileContainer
                    $circleBgSize="200px"
                    $imageUrl={proProfile}
                    $imgSize="160px"
                    $bubbleSize="200px"
                    $sizeOuterCircle="60px"
                    $sizeOuterCircleHover="200px"
                    $marginTopAndLeft="-30px"
                    $marginTopAndLeftHover="-100px"
                    $fontSize="10px"
                    $fontSizeHover="12px"
                    $letterSpacingHover="5.5px"
                  />
                </ProfilAlign>
              </AlignContent>
            </HomeColumn>
          </Row>

          <Row>
            <IntroTextAndBtn className="col-*-* App-col">
              <Parallax offset={40}>
                <AnimatedText text={phrase} className="heavyText" />
              </Parallax>

              <DevProcess isDarkMode={theme === "dark"} />

              <TextAndButton />
            </IntroTextAndBtn>
          </Row>

          <Row>
            {/* className="col-*-* App-col" */}
              {isProjectLoading ? (
                FetchLoader
              ) : (
                <WorkContainer projects={fetchedProjects} $isDark={theme === "dark"} />
              )}
          </Row>

          <ContactInfo />
        </Container>
      )}
    </>
  );
};

export default Home;
